import { Globe, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { SEO } from "../components/SEO";
import { EnquiryForm } from "../components/EnquiryForm";
import { CONTACT } from "../data/site";

export default function Contact() {
  return (
    <>
      <SEO title="Contact Us | Planning Your Warehouse Storage? — CustoRacks"
        description="Share your storage requirement with CustoRacks — pallet racking, shelving, mezzanine, cantilever, drive-in or shuttle racking. Call, WhatsApp or send an enquiry." />
      <section className="page-hero" data-testid="contact-hero">
        <div className="container">
          <div className="crumbs">Home / Contact</div>
          <h1>Planning Your Warehouse Storage?</h1>
          <p>Share your requirement with us and let us help you identify a suitable storage solution.</p>
        </div>
      </section>
      <section className="section">
        <div className="container contact-grid">
          <div>
            <span className="sec-label">Contact Details</span>
            <h2 style={{ fontSize: 30, marginBottom: 12 }}>Talk to Our Team</h2>
            <p style={{ color: "var(--muted)", marginBottom: 14 }}>Call, WhatsApp or send the enquiry form — whichever is easiest for you.</p>
            <div className="contact-info-card" data-testid="contact-phone-block">
              <Phone size={19} />
              <div><b>Phone</b><a className="val" href={CONTACT.phoneHref} data-testid="contact-phone-link">{CONTACT.phoneDisplay}</a></div>
            </div>
            <div className="contact-info-card" data-testid="contact-whatsapp-block">
              <MessageCircle size={19} />
              <div><b>WhatsApp</b><a className="val" href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link">{CONTACT.phoneDisplay} — chat with us</a></div>
            </div>
            <div className="contact-info-card" data-testid="contact-email-block">
              <Mail size={19} />
              <div><b>Email</b><a className="val" href={`mailto:${CONTACT.email}`} data-testid="contact-email-link">{CONTACT.email}</a></div>
            </div>
            <div className="contact-info-card" data-testid="contact-location-block">
              <MapPin size={19} />
              <div><b>Location</b><span>{CONTACT.address}</span></div>
            </div>
            <div className="contact-info-card" data-testid="contact-website-block">
              <Globe size={19} />
              <div><b>Website</b><span>{CONTACT.website}</span></div>
            </div>
          </div>
          <EnquiryForm />
        </div>
      </section>
    </>
  );
}
